/* eslint-disable no-param-reassign */
import {
  GET_LIST_TAG_REQUEST,
  GET_LIST_TAG_SUCCESS,
  GET_LIST_TAG_FAILURE,
  GET_TAG_REQUEST,
  GET_TAG_SUCCESS,
  GET_TAG_FAILURE,
  GET_LIST_TAG_TYPE_REQUEST,
  GET_LIST_TAG_TYPE_SUCCESS,
  GET_LIST_TAG_TYPE_FAILURE,
  CLEAR_TAG,
  CLEAR_LIST_TAG
} from "src/actions/tagActions";
import produce from "immer";

const initialState = {
  tags: [],
  tag: {},
  total: 0,
  tagTypes: [],
  loading: false
};

const stockReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TAG_REQUEST: {
      return produce(state, (draft) => {
        draft.tags = [];
        draft.loading = true;
      });
    }

    case GET_LIST_TAG_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.tags = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case GET_LIST_TAG_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_TAG_REQUEST: {
      return produce(state, (draft) => {
        draft.tag = {};
        draft.loading = true;
      });
    }

    case GET_TAG_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.tag = response;
        draft.loading = false;
      });
    }

    case GET_TAG_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_LIST_TAG_TYPE_REQUEST: {
      return produce(state, (draft) => {
        draft.tagTypes = [];
        draft.loading = true;
      });
    }

    case GET_LIST_TAG_TYPE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.tagTypes = response;
        draft.loading = false;
      });
    }

    case GET_LIST_TAG_TYPE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_TAG: {
      return produce(state, (draft) => {
        draft.tag = {};
      });
    }

    case CLEAR_LIST_TAG: {
      return produce(state, (draft) => {
        draft.tags = [];
      });
    }

    default: {
      return state;
    }
  }
};

export default stockReducer;
